import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeSalesOrders'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeSalesOrdersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeSalesOrdersStore",
			variables: false,
		})
	}
}

export async function load_HomeSalesOrders(params) {
  await initClient()

	const store = new HomeSalesOrdersStore()

	await store.fetch(params)

	return {
		HomeSalesOrders: store,
	}
}
